import { PPSOPackage, PPSOPackageRequestDto } from '@/core/ppso-package/domain/PPSO-Package.ts'
import { PPSOPackageRepository } from '@/core/ppso-package/domain/PPSOPackageRepository.ts'

type GetPPSOPackagesUseCaseDependencies = { ppsoPackageRepository: PPSOPackageRepository }

export class GetPPSOPackagesUseCase {
  private readonly ppsoPackageRepository: PPSOPackageRepository
  constructor({ ppsoPackageRepository }: GetPPSOPackagesUseCaseDependencies) {
    this.ppsoPackageRepository = ppsoPackageRepository
  }

  execute = (payload: PPSOPackageRequestDto): Promise<PPSOPackage[]> => {
    return this.ppsoPackageRepository.getAllPPSOPackages(payload)
  }
}
